export default "__VITE_ASSET__C5PF8cK5__"